import { render, staticRenderFns } from "./square-auth.vue?vue&type=template&id=39ceaa88&scoped=true&"
import script from "./square-auth.vue?vue&type=script&lang=js&"
export * from "./square-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ceaa88",
  null
  
)

export default component.exports